import React from 'react'
import styled from 'styled-components'
import notFound from "../../images/svg/not-found.svg"

const Container = styled.div`
  width: 100%;
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img-side{
      width: 45%;
      .image-box{
        width: 100%;
        height: 100%;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .text-side{
      width: 45%;
      .text-box{
        width: 100%;
        display: flex;
        flex-direction: column;
        p{
          margin-block: 10px;
          font-size: var(--font-size-sm);
          a{
            font-weight: var(--font-weight-lg);
            color: var(--color-main);
          }
        }
        h1{
          font-weight: var(--font-weight-xl);
          color: var(--color-main);
          span{
            font-weight: var(--font-weight-md);
          }
        }
      }
    }
  }
`

const NotFound = () => {
  return (
    <Container>
      <div className='content'>
        <div className="img-side">
          <div className="image-box">
            <img src={notFound} alt="404" />
          </div>
        </div>
        <div className="text-side">
          <div className="text-box">
              <h1><span>Sanırım</span> <br/>Ters Yöne Girdiniz</h1>
              <p>Sanırım bu sayfa ile ilgili bir şeyler ters gitti, ama doğru adrestesiniz.</p>
              <p>Lütfen diğer seçenekleri deneyin.</p>
              <p><a href="/">Anasayfaya</a> dönmek için tıkla.</p>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default NotFound